import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { Shimmer } from '@paypalcorp/pp-react-shimmer';
import { cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as cardStyles };
import { HeadingText } from '@paypalcorp/pp-react-text';

var _excluded = ["onClick", "label", "as", "children", "className", "isLoading", "isInverse", "size", "level"],
  _excluded2 = ["className", "children"],
  _excluded3 = ["className", "children"],
  _excluded4 = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Card = function (_ref) {
  var onClick = _ref.onClick,
    label = _ref.label,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? typeof onClick === 'function' ? 'button' : 'div' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    isLoading = _ref.isLoading,
    isInverse = _ref.isInverse,
    size = _ref.size,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? '1' : _ref$level,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var sizeStyleMap = {
    xxs: styles.sizeXxs,
    xs: styles.sizeXs,
    'xs-long': styles.sizeXsLong
  };
  var levelStyleMap = {
    '1': styles.level1,
    '3': styles.level3
  };
  var props = _objectSpread({}, rest);
  if (label) {
    props['aria-label'] = label;
  }
  var wrapperClasses = cx(styles.base, sizeStyleMap[size], levelStyleMap[level], onClick && styles.clickable, className);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: wrapperClasses,
    "data-ppui-info": "card_3.1.5__8.5.0",
    onClick: onClick
  }, props), children);
};
var Header = function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var headerClasses = cx(styles.header, className);
  var titleClasses = cx(styles.title, className);
  return /*#__PURE__*/React.createElement("header", _extends({
    className: headerClasses
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement(HeadingText, {
    size: "sm",
    className: titleClasses,
    "data-ppui": "true"
  }, children));
};
var Content = function (_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var contentClasses = cx(styles.content, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: contentClasses
  }, rest, {
    "data-ppui": "true"
  }), children);
};
var Footer = function (_ref4) {
  var className = _ref4.className,
    children = _ref4.children,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  var footerClasses = cx(styles.footer, className);
  return /*#__PURE__*/React.createElement("footer", _extends({
    className: footerClasses
  }, rest, {
    "data-ppui": "true"
  }), children);
};
Card.Header = Header;
Card.Content = Content;
Card.Footer = Footer;

export { Card };
